import e from"react";const a=({as:a="div",children:c,className:r=""})=>e.createElement(a,{className:`container ${r}`},c);export{a as Container};
//# sourceMappingURL=Container.js.map
